import MissingPatternWorksheet from "../../components/ClassOne/Mathematics/MissingPattern";
import SkipCounting from "../../components/ClassOne/Mathematics/SkipCounting";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}


const topics: MenuItem[] = [
    { url: "/class-one/mathematics/patterns/skip-counting", title: "Skip Counting", component: SkipCounting },
    { url: "/class-one/mathematics/patterns/missing-pattern", title: "Choose Missing Pattern", component: MissingPatternWorksheet },
];

export default topics;